export const TRANSACTIONS_TABLE_TITLE = 'ACH Relationships';
export const TRANSACTIONS_TABLE_INFO_URL = '';
